import React, { Dispatch, SetStateAction } from 'react';
import { Slide } from 'types';

import cx from 'classnames';
import styles from './Switcher.module.scss';

export type SwitcherProps = {
  slides: Slide[];
  active: number;
  setActive: Dispatch<SetStateAction<number>>;
  setPreviousChosen: Dispatch<SetStateAction<number>>;
};

export const Switcher = ({ slides, active, setActive, setPreviousChosen }: SwitcherProps) => {
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    // @ts-ignore
    const pointId = event.target.id;
    setPreviousChosen(active);
    setActive(+pointId);
  };

  return (
    <div className={styles.container}>
      {slides.length &&
        slides.map((_, index) => (
          <nav
            key={index}
            id={`${index}`}
            className={cx(styles.point, { [styles.active]: index == active })}
            onClick={handleClick}
          />
        ))}
    </div>
  );
};
